export function createElementFromHTML<T>(htmlString: string): T {
  const div = document.createElement('div')
  div.innerHTML = htmlString.trim()
  return div.firstChild as any as T
}

export function downloadFile(file: File) {
  const a = document.createElement('a')
  const url = window.URL.createObjectURL(file)
  a.href = url
  a.download = file.name
  a.click()
  window.URL.revokeObjectURL(url)
}

export function b64toBlob(b64Data: string, contentType = '', sliceSize = 512) {
  const byteCharacters = atob(b64Data)
  const byteArrays = []

  for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
    const slice = byteCharacters.slice(offset, offset + sliceSize)

    const byteNumbers = new Array(slice.length)
    for (let i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i)
    }

    const byteArray = new Uint8Array(byteNumbers)
    byteArrays.push(byteArray)
  }

  const blob = new Blob(byteArrays, {type: contentType})
  return blob
}
